namespace GeniuzPOS.InitialData {
    export namespace PsPriceOverrideReasonService {
        export const baseUrl = 'InitialData/PsPriceOverrideReason';

        export declare function Create(request: Serenity.SaveRequest<PsPriceOverrideReasonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPriceOverrideReasonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Undelete(request: Serenity.UndeleteRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPriceOverrideReasonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPriceOverrideReasonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsPriceOverrideReason/Create",
            Update = "InitialData/PsPriceOverrideReason/Update",
            Delete = "InitialData/PsPriceOverrideReason/Delete",
            Undelete = "InitialData/PsPriceOverrideReason/Undelete",
            Retrieve = "InitialData/PsPriceOverrideReason/Retrieve",
            List = "InitialData/PsPriceOverrideReason/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Undelete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPriceOverrideReasonService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
